module.exports = __webpack_public_path__ + "/images/ico-color-box.33c05d4.svg";